import { render, staticRenderFns } from "./CopilotFloatingBar.vue?vue&type=template&id=0f7af74d&scoped=true"
import script from "./CopilotFloatingBar.vue?vue&type=script&lang=js"
export * from "./CopilotFloatingBar.vue?vue&type=script&lang=js"
import style0 from "./CopilotFloatingBar.vue?vue&type=style&index=0&id=0f7af74d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7af74d",
  null
  
)

export default component.exports